import React from 'react';
export const Banner20DataSource = {
  wrapper: { className: 'banner2' },
  BannerAnim: {
    children: [
      {
        name: 'elem0',
        BannerElement: { className: 'banner-user-elem' },
        page: { className: 'home-page banner2-page l5kquttoryi-editor_css' },
        textWrapper: {
          className: 'banner2-text-wrapper l5kqv4qtn2-editor_css',
        },
        bg: { className: 'bg bg0' },
        title: {
          className: 'banner2-title',
          children: (
            <span>
              <span>
                <p>关于我们</p>
              </span>
            </span>
          ),
        },
        content: {
          className: 'banner2-content l5kqv418a4-editor_css',
          children: (
            <span>
              <p>专业源于专注 服务成就品质</p>
            </span>
          ),
        },
        button: {
          className: 'banner2-button l5kqv2gaxoh-editor_css',
          children: 'Learn More',
        },
      },
    ],
  },
};
export const Feature70DataSource = {
  wrapper: {
    className: 'home-page-wrapper feature7-wrapper l5kp8hfix2n-editor_css',
  },
  page: { className: 'home-page feature7 l5kpczhzjkc-editor_css' },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: 'feature7-title-wrapper l5kp8nxln7-editor_css',
    children: [
      {
        name: 'title',
        className: 'feature7-title-h1',
        children: (
          <span>
            <p>关于融云</p>
          </span>
        ),
      },
      {
        name: 'content',
        className: 'feature7-title-content l5kp9fg9w29-editor_css',
        children: (
          <span>
            <p>About Us</p>
          </span>
        ),
      },
    ],
  },
  blockWrapper: {
    className: 'feature7-block-wrapper l5kp82t8nb-editor_css',
    gutter: 24,
    children: [
      {
        md: 6,
        xs: 24,
        name: 'block0',
        className: 'feature7-block',
        children: {
          className: 'feature7-block-group',
          children: [
            {
              name: 'image',
              className: 'feature7-block-image',
              children:
                'https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg',
            },
            {
              name: 'title',
              className: 'feature7-block-title',
              children: '身份证',
            },
            {
              name: 'content',
              className: 'feature7-block-content',
              children: '识别身份证正反面姓名、身份证号、发证机关等相关信息',
            },
          ],
        },
      },
    ],
  },
};
export const Feature00DataSource = {
  wrapper: {
    className: 'home-page-wrapper content0-wrapper l5m7xluttfn-editor_css',
  },
  page: { className: 'home-page content0' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>江西融云网络科技有限公司</p>
          </span>
        ),
      },
      {
        name: 'content~l5m7z6ank3b',
        className: 'l5m7zdhpr5p-editor_css',
        children: (
          <span>
            <span>
              <p>
                特色展台包括 智慧新联会
                、赣北驾校预约管理系统、庐山市农村股权管理系统、智慧水利一体化管理系统
                等明星产品，更有产品专家
              </p>
            </span>
          </span>
        ),
      },
      {
        name: 'content~l5m81ejbb4l',
        className: 'l5m81fauh9-editor_css',
        children: (
          <span>
            <p>现场问诊，为你答疑解难</p>
          </span>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper l5m81y2f2zl-editor_css',
    children: [
      {
        name: 'block0',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children:
                'https://zos.alipayobjects.com/rmsportal/WBnVOjtIlGWbzyQivuyq.png',
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: '一站式业务接入',
            },
            { name: 'content', children: '支付、结算、核算接入产品效率翻四倍' },
          ],
        },
      },
    ],
  },
};
export const Feature20DataSource = {
  wrapper: {
    className: 'home-page-wrapper content2-wrapper l5kpi09bo5t-editor_css',
  },
  OverPack: { className: 'home-page content2', playScale: 0.3 },
  imgWrapper: { className: 'content2-img', md: 10, xs: 24 },
  img: {
    children:
      require('../static/组建/关于融云.png'),
    className: 'l5kphqqn65-editor_css',
  },
  textWrapper: {
    className: 'content2-text l5kqlr6nveu-editor_css',
    md: 14,
    xs: 24,
  },
  title: {
    className: 'content2-title l5kpgkrpzxs-editor_css',
    children: (
      <span>
        <span>
          <p>关于融云</p>
        </span>
      </span>
    ),
  },
  content: {
    className: 'content2-content',
    children: (
      <span>
        <p>
          江西融云网络科技有限公司，是一家专注于政务软件开发、销售、服务一体的公司，主要面向政府部门、事业单位、非营利组织的全方位业务管理信息化解决方案提供商。
        </p>
        <p>
          公司的业务涵盖：财政、水利、高校、银行、税务、民生、公检法等行业。
        </p>
        <p>
          核心产品和服务包括：水闸群远程监测管理项目方案、水文立杆监测项目方案、大数据产品、财政预算指标一体化解决方案、智慧统战方案、银行代理财政业务、公共资源交易中心投标保证金跨银行管理方案、行政事业单位内控信息化解决方案、基建项目库项目等。
        </p>
      </span>
    ),
  },
};
export const Feature10DataSource = {
  wrapper: {
    className: 'home-page-wrapper content1-wrapper l5kqn5c02ga-editor_css',
  },
  OverPack: { className: 'home-page content1', playScale: 0.3 },
  imgWrapper: { className: 'content1-img', md: 10, xs: 24 },
  img: {
    children:
      require('../static/组建/技术力量.png'),
    className: 'l5kqj1pq0rj-editor_css',
  },
  textWrapper: {
    className: 'content1-text l5kqjpp1q2h-editor_css',
    md: 14,
    xs: 24,
  },
  title: {
    className: 'content1-title l5kqjj9ugeq-editor_css',
    children: (
      <span>
        <span>
          <span>
            <p>技术力量</p>
          </span>
        </span>
      </span>
    ),
  },
  content: {
    className: 'content1-content l5kqjo7ev1-editor_css',
    children: (
      <span>
        <p>
          融云网络以服务社会、振兴自主软件产业为己任，经过六年不懈努力，已经形成了独特的以销售“技术服务”为特色的高科技企业，打造了一个从科学研究、设计开发、应用推广到技术服务的产业发展链条。先后承担了智慧城市之智慧教育、智能政务、智慧医疗、智慧环保、智慧城管等多行业应用平台的设计与建设工作，在区域信息化建设系列工程中发挥了重要作用，其中智慧城管、智慧教育、智慧环保等多个项目都到市委、市政府主要领导的好评并召开现场会推广。公司积极推动移动增值、软件外包等新型服务业务的发展。时至今日，升阳计算机已成为区域领先的软件服务提供商。
        </p>
      </span>
    ),
  },
};
export const Feature21DataSource = {
  wrapper: {
    className: 'home-page-wrapper content2-wrapper l5kus7rr0hq-editor_css',
  },
  OverPack: { className: 'home-page content2', playScale: 0.3 },
  imgWrapper: { className: 'content2-img', md: 10, xs: 24 },
  img: {
    children:
      require('../static/组建/服务能力.png'),
    className: 'l5kpsab2ish-editor_css',
  },
  textWrapper: { className: 'content2-text', md: 14, xs: 24 },
  title: {
    className: 'content2-title l5kpzutnhbn-editor_css',
    children: (
      <span>
        <span>
          <span>
            <span>
              <p>服务能力</p>
            </span>
          </span>
        </span>
      </span>
    ),
  },
  content: {
    className: 'content2-content',
    children: (
      <span>
        <span>
          <p>
            公司核心团队依托九江学院信息技术研究所、有大型数据中心、网络中心、数字化校园的整体解决方案的经验；
          </p>
          <p>
            公司有网络工程师、系统分析师、软件开发师、系统集成师，可以提供软硬件整理解决方案；
          </p>
          <p>
            公司和锐捷网络、华为、迪普、浪潮、Vmware、Oracle、VERITAS、爱数、海康、大华等国内外知名IT公司合作，涵盖了网络、服务器、存储、虚拟化、备份、视频监控等全方位的业务，能满足客户不同层次的服务需求。
          </p>
        </span>
      </span>
    ),
  },
};
export const Teams40DataSource = {
  wrapper: {
    className: 'home-page-wrapper content8-wrapper l5m8v4q6m2t-editor_css',
  },
  page: { className: 'home-page content8 l5kuaj7rpr-editor_css' },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <span>
              <p>专利证书</p>
            </span>
          </span>
        ),
        className: 'title-h1',
      },
    ],
  },
  block: {
    className: 'content-wrapper',
    children: [
      {
        name: 'block0',
        md: 6,
        xs: 24,
        className: 'content8-block-wrapper',
        children: {
          className: 'content8-block',
          img: {
            className: 'content8-img',
            children:
              'https://vkceyugu.cdn.bspapp.com/VKCEYUGU-734930d7-0782-4082-ab89-dc1d7326b48b/4cae840e-afe1-45ef-8fb4-085d241b01f2.jpg',
          },
          title: {
            className: 'content8-title',
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <p>智慧统战平台</p>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
          content: {
            className: 'content8-content',
            children: (
              <span>
                <p>专利证书</p>
              </span>
            ),
          },
        },
      },
      {
        name: 'block1',
        md: 6,
        xs: 24,
        className: 'content8-block-wrapper',
        children: {
          className: 'content8-block',
          img: {
            className: 'content8-img',
            children:
              'https://vkceyugu.cdn.bspapp.com/VKCEYUGU-734930d7-0782-4082-ab89-dc1d7326b48b/4cae840e-afe1-45ef-8fb4-085d241b01f2.jpg',
          },
          title: {
            className: 'content8-title',
            children: (
              <span>
                <p>智慧新联会系统</p>
              </span>
            ),
          },
          content: {
            className: 'content8-content',
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <p>专利证书</p>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block2',
        md: 6,
        xs: 24,
        className: 'content8-block-wrapper l5kukwj3bii-editor_css',
        children: {
          className: 'content8-block',
          img: {
            className: 'content8-img',
            children:
              'https://vkceyugu.cdn.bspapp.com/VKCEYUGU-734930d7-0782-4082-ab89-dc1d7326b48b/4cae840e-afe1-45ef-8fb4-085d241b01f2.jpg',
          },
          title: {
            className: 'content8-title l5kuk6g1z-editor_css',
            children: (
              <span>
                <span>
                  <span>
                    <p>财政预算指标管理系统</p>
                  </span>
                </span>
              </span>
            ),
          },
          content: {
            className: 'content8-content',
            children: (
              <span>
                <p>专利证书</p>
              </span>
            ),
          },
        },
      },
      {
        name: 'block3',
        md: 6,
        xs: 24,
        className: 'content8-block-wrapper',
        children: {
          className: 'content8-block',
          img: {
            className: 'content8-img',
            children:
              'https://vkceyugu.cdn.bspapp.com/VKCEYUGU-734930d7-0782-4082-ab89-dc1d7326b48b/4cae840e-afe1-45ef-8fb4-085d241b01f2.jpg',
          },
          title: {
            className: 'content8-title',
            children: (
              <span>
                <span>
                  <span>
                    <p>融云无插件视频平台</p>
                  </span>
                </span>
              </span>
            ),
          },
          content: {
            className: 'content8-content',
            children: (
              <span>
                <p>专利证书</p>
              </span>
            ),
          },
        },
      },
      {
        name: 'block4',
        md: 6,
        xs: 24,
        className: 'content8-block-wrapper',
        children: {
          className: 'content8-block',
          img: {
            className: 'content8-img',
            children:
              'https://vkceyugu.cdn.bspapp.com/VKCEYUGU-734930d7-0782-4082-ab89-dc1d7326b48b/4cae840e-afe1-45ef-8fb4-085d241b01f2.jpg',
          },
          title: {
            className: 'content8-title',
            children: (
              <span>
                <p>新廉购购物商城平台</p>
              </span>
            ),
          },
          content: {
            className: 'content8-content',
            children: (
              <span>
                <p>专利证书</p>
              </span>
            ),
          },
        },
      },
      {
        name: 'block5',
        md: 6,
        xs: 24,
        className: 'content8-block-wrapper',
        children: {
          className: 'content8-block',
          img: {
            className: 'content8-img',
            children:
              'https://vkceyugu.cdn.bspapp.com/VKCEYUGU-734930d7-0782-4082-ab89-dc1d7326b48b/4cae840e-afe1-45ef-8fb4-085d241b01f2.jpg',
          },
          title: {
            className: 'content8-title',
            children: (
              <span>
                <span>
                  <p>动态表单系统</p>
                </span>
              </span>
            ),
          },
          content: {
            className: 'content8-content',
            children: (
              <span>
                <p>专利证书</p>
              </span>
            ),
          },
        },
      },
      {
        name: 'block6',
        md: 6,
        xs: 24,
        className: 'content8-block-wrapper',
        children: {
          className: 'content8-block',
          img: {
            className: 'content8-img',
            children:
              'https://vkceyugu.cdn.bspapp.com/VKCEYUGU-734930d7-0782-4082-ab89-dc1d7326b48b/4cae840e-afe1-45ef-8fb4-085d241b01f2.jpg',
          },
          title: {
            className: 'content8-title',
            children: (
              <span>
                <p>财务通用凭证数据导入</p>
              </span>
            ),
          },
          content: {
            className: 'content8-content',
            children: (
              <span>
                <p>专利证书</p>
              </span>
            ),
          },
        },
      },
      {
        name: 'block7',
        md: 6,
        xs: 24,
        className: 'content8-block-wrapper',
        children: {
          className: 'content8-block',
          img: {
            className: 'content8-img',
            children:
              'https://vkceyugu.cdn.bspapp.com/VKCEYUGU-734930d7-0782-4082-ab89-dc1d7326b48b/4cae840e-afe1-45ef-8fb4-085d241b01f2.jpg',
          },
          title: {
            className: 'content8-title',
            children: (
              <span>
                <p>市政基建项目管理系统</p>
              </span>
            ),
          },
          content: {
            className: 'content8-content',
            children: (
              <span>
                <p>专利证书</p>
              </span>
            ),
          },
        },
      },
    ],
  },
};
export const Feature01DataSource = {
  wrapper: {
    className: 'home-page-wrapper content0-wrapper l5m8fcpsxnu-editor_css',
  },
  page: { className: 'home-page content0' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>服务架构</p>
          </span>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content0-block',
        md: 24,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon l5m8emul32f-editor_css',
              children:
                'https://vkceyugu.cdn.bspapp.com/VKCEYUGU-734930d7-0782-4082-ab89-dc1d7326b48b/85d13b7f-ecb0-405e-b0b0-4e136aed745f.png',
            },
          ],
        },
      },
    ],
  },
};
export const Feature40DataSource = {
  wrapper: {
    className: 'home-page-wrapper content6-wrapper l5m9bxa9kz-editor_css',
  },
  OverPack: { className: 'home-page content6 l5m9fmjhqto-editor_css' },
  textWrapper: { className: 'content6-text', xs: 24, md: 10 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <span>
              <p>企业价值与目标</p>
            </span>
          </span>
        ),
        className: 'title-h1',
      },
      {
        name: 'content',
        className: 'title-content',
        children: (
          <span>
            <p>基于阿里云计算强大的基础资源</p>
          </span>
        ),
      },
    ],
  },
  img: {
    children:
      require("../static/组建/组 31.png"),
    className: 'content6-img l5m93wdwtb-editor_css',
    xs: 24,
    md: 14,
  },
  block: {
    children: [
      {
        name: 'block0',
        img: {
          children:
            'https://zos.alipayobjects.com/rmsportal/NKBELAOuuKbofDD.png',
          className: 'content6-icon',
        },
        title: {
          className: 'content6-title',
          children: (
            <span>
              <span>
                <span>
                  <h3>
                    <b>使命</b>
                  </h3>
                </span>
              </span>
            </span>
          ),
        },
        content: {
          className: 'content6-content',
          children: (
            <span>
              <p>
                江西融云网络科技有限公司致力于创建区域经济发展新动力，推进产业导入、运营、发展的行政市场化、产业化，为社会经济发展贡献新能量！
              </p>
            </span>
          ),
        },
      },
      {
        name: 'block1',
        img: {
          className: 'content6-icon',
          children:
            'https://zos.alipayobjects.com/rmsportal/xMSBjgxBhKfyMWX.png',
        },
        title: {
          className: 'content6-title',
          children: (
            <span>
              <h3>
                <b>融合</b>
              </h3>
            </span>
          ),
        },
        content: {
          className: 'content6-content',
          children: (
            <span>
              <p>
                打造全产业链的服务平台，帮助企业科学选址，高效发展；协助政府发展产业，优化环境。实现技术、信息和服务的融合，将我们的服务覆盖到全球每一个城市。
              </p>
            </span>
          ),
        },
      },
      {
        name: 'block2',
        img: {
          className: 'content6-icon',
          children:
            'https://zos.alipayobjects.com/rmsportal/MNdlBNhmDBLuzqp.png',
        },
        title: {
          className: 'content6-title',
          children: (
            <span>
              <span>
                <h3>
                  <b>理念</b>
                </h3>
              </span>
            </span>
          ),
        },
        content: {
          className: 'content6-content',
          children: (
            <span>
              <p>服务：为商所想，为商所用，为商服务</p>
              <p>经营：融云网络，川流不息</p>
            </span>
          ),
        },
      },
      {
        name: 'block~l5m93f2xf0f',
        img: {
          className: 'content6-icon',
          children:
            'https://zos.alipayobjects.com/rmsportal/xMSBjgxBhKfyMWX.png',
        },
        title: {
          className: 'content6-title',
          children: (
            <span>
              <span>
                <span>
                  <h3>
                    <b>价值观</b>
                  </h3>
                </span>
              </span>
            </span>
          ),
        },
        content: {
          className: 'content6-content',
          children: (
            <span>
              <span>
                <p>
                  创新、执行、世范、共进<br />
                </p>
              </span>
            </span>
          ),
        },
      },
    ],
  },
};
